import Layout from "../components/Layout";
import { TransferOrder } from "../components/_Inventory/TransferOrder";

const TransferOrderPage = (props: any) => {
    return (
        <Layout>
            <TransferOrder />
        </Layout>
    )
}

export default TransferOrderPage